import { Box, Stack, TextField, Typography } from "@mui/material";
import { UFullPage, USection, UStretchSection } from "../common/ui.page";
import { GREY } from "../style/theme";
import { UButton } from "../common/ui.buttons";
import { createRef, useState } from "react";
import { useUser } from "../components/user";
import { usePlayer } from "../components/player";

export function PageNewPlayer() {
    const user = usePlayer()
    const [name, setName] = useState('')

    return <UFullPage
        justifyContent="flex-end"
        sx={{
            backgroundImage: 'url(/static/bg/bg1.png)',
            backgroundPosition: 'center top',
            backgroundRepeat: 'no-repeat',
        }}>
        <UStretchSection sx={{
            background: 'linear-gradient(0deg, rgba(30,30,30,1) 30%, rgba(30,30,30,0) 100%)',
            flexBasis: '70%',
        }}>
            <Stack spacing={2} sx={{ flex: 1, paddingY: 4 }} justifyContent="flex-end">
                <Typography sx={{ fontWeight: 500, lineHeight: 1 }}>
                    Nuovo giocatore
                </Typography>
                <Typography sx={{ color: GREY[700], lineHeight: 1, fontSize: 14 }}>
                    Scegli un nome giocatore per partecipare alla crociata, potrai modificarlo una volta creato
                </Typography>
                <TextField onChange={e => setName(e.target.value)} value={name} autoFocus size="small" />
            </Stack>
        </UStretchSection>
        <USection sx={{ background: GREY[200], paddingY: 2 }}>
            <UButton
                disabled={name.length < 3}
                call="player/edit/name"
                payload={name}
                onCall={user.reload}
                variant="contained">
                Crea giocatore
            </UButton>
        </USection>
    </UFullPage>
}